import { Component } from "@angular/core";
import { LEGAL_BASE_URL } from "../../constants/param-constants";
@Component({
    selector: "brand-footer",
    templateUrl: "brand-footer.html",
})

export class BrandFooterComponent {
  links = [
    { label: 'Terms & Conditions', page: `${LEGAL_BASE_URL}/terms` },
    { label: 'Privacy Policy', page: `${LEGAL_BASE_URL}/privacy-policy` },
  ];
  disclaimer = 'The information on this website has not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure or prevent any disease.';
  brand = 'Dr. Marty';
  year: number = new Date().getFullYear();

  // [DEV-54196] Always include noopener,noreferrer (security rule) so the opened window can't reach back via window.opener.
  openLink(url: string): void {
    window.open(url, '_blank', 'width=400, height=400, noopener, noreferrer');
  }
}
